import { render, staticRenderFns } from "./showXiangqing.vue?vue&type=template&id=8202a32a"
import script from "./showXiangqing.vue?vue&type=script&lang=js"
export * from "./showXiangqing.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports